import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import DashboardLayout from "@/components/dashboard/DashboardLayout";

const AdminLayout: React.FC = () => {
  const location = useLocation();

  // Preserve the slightly tighter vertical spacing on a couple admin views.
  const compactPaddingRoutes = ["/admin/bookings", "/admin/portfolio"];
  const padding = compactPaddingRoutes.some((prefix) => location.pathname.startsWith(prefix))
    ? "py-8"
    : "py-16";

  return (
    <div className={`section-container ${padding}`}>
      <DashboardLayout variant="admin">
        <Outlet />
      </DashboardLayout>
    </div>
  );
};

export default AdminLayout;
